// extracted by mini-css-extract-plugin
export var button = "style-mod--button--99a95";
export var crossSellText = "style-mod--cross-sell-text--7e7d8";
export var crossSellVariantTitle = "style-mod--cross-sell-variant-title--da737";
export var outOfStock = "style-mod--out-of-stock--37d33";
export var outOfStockInfo = "style-mod--out-of-stock-info--d7295";
export var price = "style-mod--price--5f329";
export var priceBox = "style-mod--price-box--233b2";
export var priceText = "style-mod--price-text--c4745";
export var primaryCrossSell = "style-mod--primary-cross-sell--8d106";
export var productImage = "style-mod--product-image--9536a";
export var selectedVariant = "style-mod--selected-variant--5cc5a";
export var squareImg = "style-mod--square-img--2bac3";
export var upsellVariant = "style-mod--upsell-variant--93d08";
export var variantAddedBox = "style-mod--variant-added-box--9c140";
export var variantButtons = "style-mod--variant-buttons--22b62";
export var variantIsSelected = "style-mod--variant-is-selected--6f485";